import script from "./SpecialNote.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpecialNote.vue?vue&type=script&lang=ts&setup=true"

import "./SpecialNote.vue?vue&type=style&index=0&id=5e87c064&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e87c064"]])

export default __exports__